import { Button, Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import ConfirmationModal from '../../../../app/components/modals/ConfirmationModal'
import CustomFormModal from '../../../../app/components/modals/CustomFormModal'
import { PlusOutlined } from '@ant-design/icons';
import { IParcelPerfectConfiguration, ISupplier } from '../../../../app/models/Supplier'
import SupplierConfigurationTableComponent from './SupplierConfigurationTableComponent';
import SupplierConfigurationForm from './SupplierConfigurationForm';

interface IProps {
	supplier: Partial<ISupplier>;
	setSupplier: (collection: Partial<ISupplier>) => void;
	validateCallback?: (value: boolean) => void;
}

const SupplierConfigurationComponent: React.FC<IProps> = ({ supplier, setSupplier, validateCallback }) => {

	const [loading, setLoading] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [contentToModify, setContentToModify] = useState<IParcelPerfectConfiguration>();

	const onDelete = async (record: IParcelPerfectConfiguration) => {
		setContentToModify(record);
		setShowDeleteModal(true);
	}

	const onEdit = async (record: IParcelPerfectConfiguration) => {
		setContentToModify(record);
		setShowEditModal(true);
	}

	const setConfigurations = (configs: IParcelPerfectConfiguration[]) => {
		setSupplier({...supplier, parcelPerfectConfigurations: configs})
	}

	const validate = () => {
		if (validateCallback) {
			validateCallback(true);
		}
	}

	useEffect(() => {
		validate();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [supplier.emails])

	return (
		<>
			<Row style={{ paddingBottom: '3px' }}>
				<Col style={{ marginLeft: 'auto' }}>
					<Button type='link' onClick={() => setShowCreateModal(true)} icon={<PlusOutlined />}></Button>
				</Col>
			</Row>

			<SupplierConfigurationTableComponent 
				data={supplier.parcelPerfectConfigurations} 
				loading={loading} 
				onDelete={onDelete} 
				onEdit={onEdit} 
			/>

			<ConfirmationModal
				callback={async () => {
					setLoading(true);
					setConfigurations([...supplier.parcelPerfectConfigurations!.filter(x => x !== contentToModify)])
					setLoading(false);
				}}
				message={`Please confirm deletion`}
				visible={showDeleteModal}
				setVisible={setShowDeleteModal}
			/>
			<CustomFormModal
				setVisible={setShowCreateModal}
				title={'Add email'}
				visible={showCreateModal}
			>
				<SupplierConfigurationForm 
					editMode={false} 
					closeModal={(result) => {
						setConfigurations([...supplier.parcelPerfectConfigurations ?? [], result]);
						setShowCreateModal(false);
					}} 
				/>
			</CustomFormModal>
			<CustomFormModal
				setVisible={setShowEditModal}
				title={'Update contents'}
				visible={showEditModal}
			>
				<SupplierConfigurationForm 
					initialValue={contentToModify}
					editMode={true} 
					closeModal={(result) => {
						setConfigurations([...supplier.parcelPerfectConfigurations!.filter(x => x !== contentToModify), result]);
						setShowEditModal(false);
					}} 
				/>
			</CustomFormModal>
		</>
	)
}

export default SupplierConfigurationComponent
